import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "../button/button.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pending-sr-modal',
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './pending-sr-modal.component.html',
  styleUrl: './pending-sr-modal.component.scss'
})
export class PendingSrModalComponent {
  @Input() srNumber: string = "";
  @Output() onClose = new EventEmitter();

  // This method is used to close success modal
  closeSuccessModal() {
    this.onClose.emit();
  }
  // This method is used to continue sr
  continueSR() {
    this.onClose.emit();
  }
}
